<template>
  <el-card
    class="settings"
    shadow="never">
    <div
      slot="header"
      class="settings-header">
      通用设置
    </div>
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="120px">
      <el-form-item
        label="页面名称："
        prop="pageName">
        <el-input
          v-model="form.pageName"
          placeholder="请输入页面名称"></el-input>
      </el-form-item>
      <el-form-item
        label="小程序标题："
        prop="pageTitle">
        <el-input
          v-model="form.pageTitle"
          placeholder="请输入页面名称"></el-input>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'WeHeader',
  components: { },
  props: {
    value: {
      type: Object,
      default() {
        return { pageName: '', pageTitle: '' }
      }
    }
  },
  data() {
    return {
      // styles: [
      //   { name: '样式1', ruleType: 1, png: require('../image/t1/5.png') },
      //   { name: '样式2', ruleType: 2, png: require('../image/t2/5.png') },
      //   { name: '样式3', ruleType: 3, png: require('../image/t3/5.png') }
      // ],
      // tabbarOptions: [
      //   { label: '首页', value: 0, disabled: true },
      //   { label: '商城', value: 1, disabled: false },
      //   { label: '购物车', value: 2, disabled: true },
      //   { label: '我的', value: 3, disabled: true }
      // ],
      rules: {
        pageName: [
          { required: true, message: '请输入页面名称', trigger: 'blur' }
        ],
        pageTitle: [
          { required: true, message: '请输入页面名称', trigger: 'blur' }
        ],
        orderButtonImage: [
          { required: false, message: '请上传商品卡片按钮', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    }),
    form: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    submit() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(v => {
          if (v) {
            resolve()
          } else {
            reject(new Error(JSON.stringify({ pop: 'headers' })))
          }
        })
      })
    }
  }
}
</script>
<style lang="stylus">
.settings {
  // display: flex;
  // flex-direction: column;
}

.settings .el-card__header {
  padding: 10px 20px;
}

.settings .el-card__body {
  // flex: 1;
  padding: 10px;
  // display: flex;
  // flex-direction: column;
}

.settings .settings-header {
  font-size: 16px;
  font-weight: 600;
}
</style>
